import React from 'react';
import styled, { css } from 'react-emotion';
import PricingTable from './PricingTable';
import PlanComparison from './PlanComparison';
// const CenterWrapper = styled('div')({
//   color: 'red',
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gridGap: '10px',
//   gridAutoRows: '200px',
//   gridTemplateAreas: `
//     ". a a ."
//     ". a a ."
//     `,
// });

const CenterWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  flexDirection: 'column',
});

const planHeader = css({
  textAlign: 'center',
});

const subText = css({
  fontSize: 16,
  fontWeight: 400,
  color: '#888',
});

class Pricing extends React.Component {
  render() {
    return (
      <CenterWrapper>
        <div className="container">
          <div className={planHeader}>
            <h2>Lattix Sight Pricing</h2>
            <p className={subText}>
              This one shows 4 plans including a free one
            </p>
          </div>
          <PricingTable />
          <div className={planHeader}>
            <h2>Compare Plans</h2>
          </div>
          <PlanComparison />
        </div>
      </CenterWrapper>
    );
  }
}

export default Pricing;



// WEBPACK FOOTER //
// ./src/views/public/Pricing/index.js